// MYS-7471: the embedded apps that log in to PS3 through the MyServices identity provider. An
// Operator holding any of them is provisioned in PS3 (core user, DOMAIN_ACCESS on the client's
// billing domain, Keycloak link); the access is revoked only once they hold none.
//
// Matched by exact link: the appComponent entry ids differ per environment, the links do not.
// - /app/DiscountEditor: the Flexible Pricing Engine (Discount Editor). Not /app/DiscountEditorDev.
// - /app/billingManager: the prod Billing Manager. On prod it shares the billing1 PS3 (core and
//   Keycloak) with the Discount Manager, so one PS3 user serves both apps. The stage instances
//   (/app/billingManager/billing-staging, …/billing1, …/billing-qa1, …) each run their own PS3,
//   which api2 does not provision, so they must not match.
export const PS3_APP_LINKS = [ '/app/DiscountEditor', '/app/billingManager' ]

export function isPs3AppLink(link: string | undefined): boolean {
	return !!link && PS3_APP_LINKS.includes(link)
}
